import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer>
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Nalumer</h3>
            <p>Υπηρεσία catering με πάθος για την τέλεια γεύση και την κομψή παρουσίαση. Δημιουργούμε αξέχαστες γαστρονομικές εμπειρίες για κάθε εκδήλωση.</p>
            <p>Αριθμός Μητρώου: 42936013</p>
          </div>
          
          <div className="footer-section">
            <h3>Γρήγορες Συνδέσεις</h3>
            <ul>
              <li><Link to="/">Αρχική</Link></li>
              <li><Link to="/about">Σχετικά με εμάς</Link></li>
              <li><Link to="/contact">Επικοινωνία</Link></li>
              <li><Link to="/privacy-policy">Πολιτική Απορρήτου</Link></li>
              <li><Link to="/terms-conditions">Όροι Χρήσης</Link></li>
              <li><Link to="/refund-policy">Πολιτική Επιστροφών</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>Επικοινωνία</h3>
            <p>Λεωφόρος Παπανικολάου, 99</p>
            <p>36508, Προσοτσάνη, Ελλάδα</p>
            <p>Τηλέφωνο: +59955812136</p>
            <p>Email: <a href="mailto:nalumer@hotmail.com">nalumer@hotmail.com</a></p>
            <p><a href="https://wa.me/59955812136">WhatsApp</a></p>
            <p><a href="https://viber.me/59955812136">Viber</a></p>
          </div>
          
          
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2026 Nalumer. Όλα τα δικαιώματα διατηρούνται.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;